import { createContext } from "react";
import type { GoOfflineContextValue } from "../types";

export const GoOfflineContext = createContext<GoOfflineContextValue | null>(null);
